"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyInput = void 0;
const React = __importStar(require("react"));
const currency_input_styled_1 = require("./currency-input.styled");
const CurrencyInput = (props) => {
    const convertCurrency = (c) => {
        const upperCaseCurrency = c === null || c === void 0 ? void 0 : c.toUpperCase();
        switch (upperCaseCurrency) {
            case 'USD':
                return '$ - USD';
            case 'EUR':
                return '€ - EUR';
            default:
                return '£ - GBP';
        }
    };
    const classNames = [];
    if (props.className)
        classNames.push(props.className);
    const rtiProps = Object.assign(Object.assign({}, props), { type: 'text', className: classNames.join(' ') });
    return React.createElement(currency_input_styled_1.StyledCurrencyInput, { id: props.id },
        React.createElement("div", { className: "currency__label" }, convertCurrency(props.currency)),
        React.createElement("input", Object.assign({}, rtiProps)));
};
exports.CurrencyInput = CurrencyInput;
//# sourceMappingURL=CurrencyInput.js.map